module.exports = __webpack_public_path__ + "static/img/index_banner8.86648c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner8.jpg
// module id = S4rC
// module chunks = 1